import * as types from '../constants/ActionTypes';
export const initialState = {
    loggedIn: false,
    token: '',
    user: null,
    authenticating: false,
    firstLogin: false,
    setupForceOpened: false,
    unauthenticated: false,
    trialModalClosed: false,
    trialEndModalClosed: false,
    trialNewlyActivated: false,
    invitedOrganization: null,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case types.AUTHENTICATING_USER:
            return {
                ...state,
                authenticating: true,
                token: action.payload ? action.payload.token : null,
                firstLogin: action.payload ? action.payload.firstLogin : false,
                setupForceOpened: false,
                unauthenticated: false,
            };
        case types.FORCE_SETUP_OPEN:
            return {
                ...state,
                setupForceOpened: 'payload' in action ? action.payload : true,
            };
        case types.LOGGED_USER: {
            const { fetchedPullRequestsProgress, fetchedRepositoriesProgress } = action.payload;
            const isLoadingPrOrRepositories = (fetchedPullRequestsProgress !== null && fetchedPullRequestsProgress < 1) ||
                (fetchedRepositoriesProgress !== null && fetchedRepositoriesProgress < 1);
            return {
                ...state,
                loggedIn: true,
                user: { ...state.user, ...action.payload, isLoadingPrOrRepositories: isLoadingPrOrRepositories },
                authenticating: false,
                unauthenticated: false,
            };
        }
        case types.LOGOUT_USER:
            return {
                ...state,
                loggedIn: false,
                token: '',
                user: null,
                authenticating: false,
                unauthenticated: false,
            };
        case types.UNAUTHENTICATED_USER:
            return {
                ...state,
                loggedIn: false,
                token: '',
                user: null,
                authenticating: false,
                firstLogin: false,
                unauthenticated: true,
            };
        case types.TRIAL_MODAL_CLOSED:
            return { ...state, trialModalClosed: true };
        case types.TRIAL_END_MODAL_CLOSED:
            return { ...state, trialEndModalClosed: true };
        case types.TOGGLE_TRIAL_NEWLY_ACTIVATED:
            return {
                ...state,
                trialNewlyActivated: !state.trialNewlyActivated,
            };
        case types.SET_INVITED_ORGANIZATION:
            return {
                ...state,
                invitedOrganization: {
                    alreadyPart: Boolean(action.payload &&
                        state.user &&
                        state.user.organizations.filter((org) => org.id === action.payload.id).length > 0),
                    organization: action.payload,
                },
            };
        case types.CLEAR_INVITED_ORGANIZATION:
            return { ...state, invitedOrganization: null };
        default:
            return state;
    }
};
